import { FileLinks } from 'admin/documents/FileLinks';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { CollisionInsuranceProduct } from 'generated/graphql';
import {
  ArrayField,
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  NumberField,
  ReferenceField,
  RichTextField,
  SelectField,
  Show,
  SingleFieldList,
  TabbedShowLayout,
  TextField,
} from 'react-admin';

import { PRODUCT_STATUS_CHOICES } from '../productUtils';

export const CollisionInsuranceProductShow: React.FC = () => (
  <Show>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Základné info">
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <TextField label="Inštitúcia" source="institution.name" />
        <TextField label="Vlastná inštitúcia" source="institutionName" />
        <TextField label="Názov produktu" source="name" />
        <BooleanField label="Starostlivosť" source="enableFinancialAdvisorCare" />
        <ArrayField label="Dokumenty" source="documents">
          <SingleFieldList linkType={false}>
            <ArrayField source="files">
              <FileLinks />
            </ArrayField>
          </SingleFieldList>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Zmluva">
        <TextField label="Číslo zmluvy" source="contractNumber" />
        <DateField label="Začiatok poistenia" locales="sk" source="contractSignDate" />
        <DateField label="Platnosť poistenia do" locales="sk" source="contractEndDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Platby">
        <FunctionField
          label="Suma poistného"
          render={(record: CollisionInsuranceProduct) =>
            record.paymentPeriod?.expectedAmount?.amount ? -record.paymentPeriod?.expectedAmount?.amount : undefined
          }
          source="paymentPeriod.expectedAmount.amount"
        />
        <TextField label="Opakovať každých" source="paymentPeriod.periodCount" />
        <SelectField choices={PERIOD_TYPE_CHOICES} label="" source="paymentPeriod.periodTypeCode" />
        <DateField label="Nasledujúca platba" locales="sk" source="paymentPeriod.expectedDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Údaje pre platbu">
        <TextField label="Variabilný symbol" source="paymentInfo.variableSymbol" />
        <TextField label="Špecifický symbol" source="paymentInfo.specificSymbol" />
        <TextField label="Konštantný symbol" source="paymentInfo.constantSymbol" />
        <TextField label="IBAN" source="paymentInfo.ibanForPayment" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistené vozidlo">
        <TextField label="Typ vozidla" source="vehicleInfo.type" />
        <TextField label="Rok výroby" source="vehicleInfo.manufactureYear" />
        <TextField label="ŠPZ" source="vehicleInfo.licenseNumber" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistené riziká">
        <ArrayField label={false} source="insuranceRisks">
          <Datagrid bulkActionButtons={false}>
            <TextField label="Typ rizika" source="type" />
            <TextField label="Názov rizika" source="name" />
            <TextField label="Poistná suma" source="insuredSum.amount" />
            <TextField label="Poistné" source="annualCost.amount" />
          </Datagrid>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistník">
        <TextField label="Typ poistníka" source="insuringPerson.type" />
        <TextField label="Názov spoločnosti / Meno" source="insuringPerson.name" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Údaje pre porovnanie výhodnosti produktu">
        <DateField label="Dátum narodenia" locales="sk" source="vehicleInfo.owner.dateOfBirth" />
        <TextField label="PSČ" source="vehicleInfo.owner.postalCode" />
        <NumberField label="Rok poslednej nehody" source="vehicleInfo.owner.yearOfLastCollision" />
        <NumberField label="Počet nehôd za 3 roky" source="vehicleInfo.owner.numberOfRecentCollisions" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Status">
        <SelectField choices={PRODUCT_STATUS_CHOICES} label="Status" source="status" />
        <DateField label="Zmena stavu" locales="sk" source="statusChangeDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poznámka">
        <RichTextField label="Poznámka" source="note" />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
